export default "__VITE_ASSET__CqoD6pfC__"